import React, { useState } from 'react';

import { Button, Sheet } from '@betterment/samba-react';

import { Drawer } from '../../../activity/components/drawer/Drawer';
import { trackClick } from '../../../features/track';
import { ActivityItemFragment } from '../../../graphql/fragments/activityItem.generated';

type Props = {
  pendingOrder: ActivityItemFragment;
};

export const OrderDetailsLink: React.FC<Props> = ({ pendingOrder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    trackClick({ name: 'pendingOrderSeeDetail' });
  };

  return (
    <Sheet overlay="weak" open={isOpen} onOpenChange={setIsOpen}>
      <Sheet.Trigger asChild={true}>
        <Button variant="textPrimary" onClick={handleClick}>
          See details
        </Button>
      </Sheet.Trigger>

      <Sheet.Content
        css={{ overflowY: 'auto', gap: 'space.300', zIndex: '300' }}
        onOpenAutoFocus={e => e.preventDefault()}
      >
        <Drawer item={pendingOrder} />
      </Sheet.Content>
    </Sheet>
  );
};
